module.exports = __webpack_public_path__ + "img/Veranza-6-min.866fd00b.jpg";